export default {
  name: 'cco:RecommendedStepsCard',
  title: 'Card with recommended steps',
  owner: 'System',
  solution: '',
  tags: ['widget', 'card', 'recommended steps'],
  createdAt: 'Feb 20, 2024, 10:14 AM',
  updatedAt: 'Feb 25, 2024, 9:59 PM',
  spec: {
    props: {
      step1Title: 'Step 1 Title',
      step1Desc: 'Step 1 Desc',
      step1ClickHandler: 'Step 1 Link',
      step1IsIcon: false,
      step2Title: 'Step 2 Title',
      step2Desc: 'Step 2 Desc',
      step2ClickHandler: 'Step 2 Link',
      step2IsIcon: false,
      step3Title: 'Step 3 Title',
      step3Desc: 'Step 3 Desc',
      step3ClickHandler: 'Step 3 Link',
      step3IsIcon: false,
      asset: 'img.svg',
      background: 'default-bg-weak',
      closeHandler: 'closeHandler',
      stepsComplete: false,
    },
    view: [
      {
        instanceOf: 'div',
        className: '${ "flex" }',
        children: [
          [
            'dashify:If',
            {
              condition: '/${ ( $boolean(props.stepsComplete) = false ) }',
            },
            [
              [
                'dashify:Then',
                {},
                [
                  [
                    'div',
                    {
                      '.': 'flex flex-col items-start self-stretch bg-default-bg-weak gap-4 p-5 rounded-xl border-l-8 ml-3 mr-4 w-full',
                      style: {
                        borderLeftColor: '#6977F0',
                        boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.08)',
                      },
                    },
                    [
                      [
                        'div',
                        {
                          '.': 'flex w-full justify-between',
                          style: { font: 'var(--typography-heading-sub-section)', color: 'var(--default-text-strong)' },
                        },
                        [
                          ['div', {}, 'Recommended setup steps'],
                          [
                            'div',
                            {
                              '.': 'hover:cursor-pointer',
                            },
                            [
                              [
                                'uik:Icon.Action.Disable',
                                {
                                  size: 'SMALL',
                                  onClick: '/${ props.closeHandler }',
                                },
                              ],
                            ],
                          ],
                        ],
                      ],
                      [
                        'div',
                        { '.': 'flex w-full pt-3' },
                        [
                          [
                            'div',
                            { '.': 'flex-col items-start mr-5 w-3/4' },
                            [
                              [
                                'div',
                                { '.': 'flex p-4' },
                                [
                                  [
                                    'dashify:If',
                                    {
                                      condition: '/${ ( $boolean(props.step1IsIcon) = true ) }',
                                    },
                                    [
                                      [
                                        'dashify:Then',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex flex-col justify-center items-center rounded-3xl border-solid border-2 bg-default-bg-weak w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-bg-medium)',
                                                borderColor: 'var(--interact-border-medium)',
                                              },
                                            },
                                            [
                                              [
                                                'uik:Icon.Action.Enable',
                                                {
                                                  size: 'SMALL',
                                                  fill: 'var(--interact-border-medium)',
                                                },
                                              ],
                                            ],
                                          ],
                                        ],
                                      ],
                                      [
                                        'dashify:Else',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex justify-center items-center rounded-3xl bg-interact-bg-medium w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-text-in)',
                                              },
                                            },
                                            '1',
                                          ],
                                        ],
                                      ],
                                    ],
                                  ],
                                  [
                                    'div',
                                    { '.': 'flex-col ml-4' },
                                    [
                                      [
                                        'div',
                                        {
                                          '.': 'hover:cursor-pointer ',
                                          style: {
                                            font: 'var(--typography-p3-emphasis)',
                                            color: 'var(--interact-text)',
                                            '&:hover': {
                                              color: 'var(--interact-text)',
                                            },
                                          },
                                          onClick: '/${ props.step1ClickHandler }',
                                        },
                                        '/${ props.step1Title }',
                                      ],
                                      [
                                        'div',
                                        {
                                          '.': 'mt-1',
                                          style: {
                                            font: 'var(--typography-p3-default)',
                                            color: 'var(--default-text-medium)',
                                          },
                                        },
                                        '/${ props.step1Desc }',
                                      ],
                                    ],
                                  ],
                                ],
                              ],
                              ['div', { '.': 'flex-col self-stretch items-start bg-control-border-weak h-px' }],
                              [
                                'div',
                                { '.': 'flex p-4' },
                                [
                                  [
                                    'dashify:If',
                                    {
                                      condition: '/${ ( $boolean(props.step2IsIcon) = true ) }',
                                    },
                                    [
                                      [
                                        'dashify:Then',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex flex-col justify-center items-center rounded-3xl border-solid border-2 bg-default-bg-weak w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-bg-medium)',
                                                borderColor: 'var(--interact-border-medium)',
                                              },
                                            },
                                            [
                                              [
                                                'uik:Icon.Action.Enable',
                                                {
                                                  size: 'SMALL',
                                                  fill: 'var(--interact-border-medium)',
                                                },
                                              ],
                                            ],
                                          ],
                                        ],
                                      ],
                                      [
                                        'dashify:Else',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex justify-center items-center rounded-3xl bg-interact-bg-medium w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-text-in)',
                                              },
                                            },
                                            '2',
                                          ],
                                        ],
                                      ],
                                    ],
                                  ],
                                  [
                                    'div',
                                    { '.': 'flex-col ml-4' },
                                    [
                                      [
                                        'div',
                                        {
                                          '.': 'hover:cursor-pointer ',
                                          style: {
                                            font: 'var(--typography-p3-emphasis)',
                                            color: 'var(--interact-text)',
                                            '&:hover': {
                                              color: 'var(--interact-text)',
                                            },
                                          },
                                          onClick: '/${ props.step2ClickHandler }',
                                        },
                                        '/${ props.step2Title }',
                                      ],
                                      [
                                        'div',
                                        {
                                          '.': 'mt-1',
                                          style: {
                                            font: 'var(--typography-p3-default)',
                                            color: 'var(--default-text-medium)',
                                          },
                                        },
                                        '/${ props.step2Desc }',
                                      ],
                                    ],
                                  ],
                                ],
                              ],
                              ['div', { '.': 'flex-col self-stretch items-start bg-control-border-weak h-px' }],
                              [
                                'div',
                                { '.': 'flex p-4' },
                                [
                                  [
                                    'dashify:If',
                                    {
                                      condition: '/${ ( $boolean(props.step3IsIcon) = true ) }',
                                    },
                                    [
                                      [
                                        'dashify:Then',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex flex-col justify-center items-center rounded-3xl border-solid border-2 bg-default-bg-weak w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-bg-medium)',
                                                borderColor: 'var(--interact-border-medium)',
                                              },
                                            },
                                            [
                                              [
                                                'uik:Icon.Action.Enable',
                                                {
                                                  size: 'SMALL',
                                                  fill: 'var(--interact-border-medium)',
                                                },
                                              ],
                                            ],
                                          ],
                                        ],
                                      ],
                                      [
                                        'dashify:Else',
                                        {},
                                        [
                                          [
                                            'div',
                                            {
                                              '.': 'flex justify-center items-center rounded-3xl bg-interact-bg-medium w-7 h-7',
                                              style: {
                                                font: 'var(--typography-p3-emphasis)',
                                                color: 'var(--interact-text-in)',
                                              },
                                            },
                                            '3',
                                          ],
                                        ],
                                      ],
                                    ],
                                  ],
                                  [
                                    'div',
                                    { '.': 'flex-col ml-4' },
                                    [
                                      [
                                        'div',
                                        {
                                          '.': 'hover:cursor-pointer ',
                                          style: {
                                            font: 'var(--typography-p3-emphasis)',
                                            color: 'var(--interact-text)',
                                            '&:hover': {
                                              color: 'var(--interact-text)',
                                            },
                                          },
                                          onClick: '/${ props.step3ClickHandler }',
                                        },
                                        '/${ props.step3Title }',
                                      ],
                                      [
                                        'div',
                                        {
                                          '.': 'mt-1',
                                          style: {
                                            font: 'var(--typography-p3-default)',
                                            color: 'var(--default-text-medium)',
                                          },
                                        },
                                        '/${ props.step3Desc }',
                                      ],
                                    ],
                                  ],
                                ],
                              ],
                            ],
                          ],
                          [
                            'div',
                            { '.': 'w-2/5' },
                            [
                              [
                                'img',
                                {
                                  src: '/${ props.asset }',
                                  height: '240px',
                                  width: '453px',
                                },
                              ],
                            ],
                          ],
                        ],
                      ],
                    ],
                  ],
                ],
              ],
              [
                'dashify:Else',
                {},
                [
                  [
                    'div',
                    {
                      '.': 'flex flex-col items-start self-stretch bg-default-bg-weak gap-4 p-6 rounded-xl ml-3 mr-4 w-full',
                      style: {
                        boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.08)',
                      },
                    },
                    [
                      [
                        'div',
                        {
                          '.': 'flex w-full justify-between',
                          style: { font: 'var(--typography-heading-sub-section)', color: 'var(--default-text-strong)' },
                        },
                        [
                          ['div', {}, 'Recommended Steps Complete'],
                          [
                            'div',
                            {
                              '.': 'hover:cursor-pointer',
                            },
                            [
                              [
                                'uik:Icon.Action.Disable',
                                {
                                  size: 'SMALL',
                                  onClick: '/${ props.closeHandler }',
                                },
                              ],
                            ],
                          ],
                        ],
                      ],
                      [
                        'div',
                        { '.': 'flex w-full' },
                        [
                          [
                            'div',
                            { '.': 'flex-col items-start mr-5 w-3/4' },
                            [
                              [
                                'div',
                                { '.': 'flex-col' },
                                [
                                  [
                                    'div',
                                    { '.': 'flex' },
                                    [
                                      [
                                        'div',
                                        {
                                          '.': 'mt-1',
                                          style: {
                                            font: 'var(--typography-p3-default)',
                                            color: 'var(--default-text-medium)',
                                          },
                                        },
                                        [
                                          ['span', {}, 'You have completed the initial setup, for more details '],
                                          [
                                            'span',
                                            {
                                              '.': 'hover:cursor-pointer no-underline',
                                              style: {
                                                font: 'var(--typography-p3-bold)',
                                                color: 'var(--interact-text)',
                                                '&:hover': {
                                                  color: 'var(--interact-text)',
                                                },
                                              },
                                              onClick: '/${ function($e){ $emitShellEvent("HELP_CENTER_OPEN")} }',
                                            },
                                            'view the complete setup guide.',
                                          ],
                                        ],
                                      ],
                                    ],
                                  ],
                                ],
                              ],
                            ],
                          ],
                          [
                            'div',
                            { '.': 'w-2/5' },
                            [
                              [
                                'img',
                                {
                                  src: '/${ props.asset }',
                                  height: '240px',
                                  width: '453px',
                                },
                              ],
                            ],
                          ],
                        ],
                      ],
                    ],
                  ],
                ],
              ],
            ],
          ],
        ],
      },
    ],
  },
};
